import { AnalyticsEventParams } from 'hooks/analytics/model-analytics'

import { ParticipanteEditableTableModel } from './componentes/participantes/ParticipanteEditableTable'
import { AtividadeColetivaGruposFormModel } from './grupos/model-atividadeColetivaGrupos'
import { AtividadeColetivaFormModel } from './model-atividadeColetiva'

export function getParamsAtividadeColetivaSaude(values: AtividadeColetivaFormModel): AnalyticsEventParams {
  const participantes = values.participantes ?? []

  return {
    tipo_atividade: values.tipoAtividade,
    qtd_participantes: participantes.length,
    usou_grupo: !!values.grupoParticipante,
    informou_medicoes: participantes.some(hasMedicao),
    informou_avaliacao_alterada: participantes.some((participante) => participante.avaliacaoAlterada),
  }
}

export function getParamsGrupoAtividadeColetiva(values: AtividadeColetivaGruposFormModel): AnalyticsEventParams {
  return getParamsGrupo(
    values.tipoGrupo,
    values.cidadaosParticipantes?.length ?? 0,
    values.lotacoesEnvolvidas?.length ?? 0
  )
}

export function getParamsGrupo(tipoGrupo: string, qtdCidadaos: number, qtdLotacoes: number): AnalyticsEventParams {
  return {
    tipo_grupo: tipoGrupo,
    qtd_cidadaos: qtdCidadaos,
    qtd_lotacoes: qtdLotacoes,
  }
}

const hasMedicao = (participante: ParticipanteEditableTableModel) => !!participante.peso || !!participante.altura
